<footer>
  <cx-page-layout section="footer"></cx-page-layout>
  <cx-page-layout section="checkoutFooter"></cx-page-layout>
</footer>
